import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9afb9f9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["scrollLeft"]
const _hoisted_2 = { class: "onboarding-million-users16167__people" }
const _hoisted_3 = ["src"]

import { computed, ref } from 'vue'

import { getImage, QuestionnaireView } from '@/models/onboarding'
import { MillionUsers16167Page } from '@/models/onboarding.types'
import { PublicInterface } from '@/models/interfaces'

import Rive from '@/app/components/Rive.vue'
import Layout from '../Layout.vue'
import MillionUsers16167Testimonial from '../MillionUsers16167Testimonial.vue'
import { platform } from '@/services/platform'


export default /*#__PURE__*/_defineComponent({
  __name: 'MillionUsers16167',
  props: {
    view: null
  },
  setup(__props: any) {

const props = __props as {
  view: PublicInterface<QuestionnaireView>
};



const riveRef = ref<InstanceType<typeof Rive> | null>(null)
const testimonialsRef = ref<
  InstanceType<typeof MillionUsers16167Testimonial>[]
>([])

const finishedIntroAnimation = ref(false)

/**
 * Set the scroll position of the carousel
 * to the item matching the current subpage index.
 */
const testimonialsScrollPosition = computed(() => {
  if (testimonialsRef.value.length === 0) {
    return 0
  }
  const index = props.view.currentSubpageIndex
  const currentTestimonial = testimonialsRef.value[index]
  return currentTestimonial.$el.offsetWidth * (index + 1)
})

const page = computed(() => {
  return props.view.currentPage as MillionUsers16167Page
})

const rive = computed(() => {
  return riveRef.value?.rive
})

const reverseContentArray = computed(() => {
  return [...page.value.content].reverse()
})

function showTestimonials(): void {
  if (finishedIntroAnimation.value) {
    return
  }

  finishedIntroAnimation.value = true

  if (platform.isDesktopWidth()) {
    rive.value?.play('desktopZoom')
  } else {
    rive.value?.play('mobileZoom')
  }

  setTimeout(() => {
    props.view.showContinueButton()
  }, 2300)
}

function getTestimonialImage(image: string): string {
  return require(`@/assets.v2/images/${image}`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: _normalizeClass(["onboarding-million-users16167", {
      'onboarding-million-users16167--loaded': riveRef.value?.isLoaded,
      'onboarding-million-users16167--show-testimonials':
        finishedIntroAnimation.value,
    }]),
    title: _unref(page).title,
    subtitle: _unref(page).subtitle
  }, {
    default: _withCtx(() => [
      (finishedIntroAnimation.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "onboarding-million-users16167__testimonials",
            scrollLeft: _unref(testimonialsScrollPosition)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reverseContentArray), (person, index) => {
              return (_openBlock(), _createBlock(MillionUsers16167Testimonial, {
                ref_for: true,
                ref_key: "testimonialsRef",
                ref: testimonialsRef,
                key: person.name,
                image: getTestimonialImage(person.image),
                person: person,
                isActive: __props.view.currentSubpageIndex === index
              }, null, 8, ["image", "person", "isActive"]))
            }), 128))
          ], 8, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(page).content, (person, index) => {
          return (_openBlock(), _createElementBlock("img", {
            key: person.name,
            src: getTestimonialImage(person.image),
            alt: "",
            width: "90",
            height: "90",
            class: "onboarding-million-users16167__person",
            style: _normalizeStyle({ '--popup-delay': index })
          }, null, 12, _hoisted_3))
        }), 128))
      ]),
      _createVNode(Rive, {
        ref_key: "riveRef",
        ref: riveRef,
        class: "onboarding-million-users16167__rive",
        src: _unref(getImage)(_unref(page).animation.src),
        fit: "Layout",
        onStop: showTestimonials
      }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["class", "title", "subtitle"]))
}
}

})